export default __webpack_public_path__ + "static/media/EILogo.4d6a1265.jpg";